import MuiRte from 'mui-rte'
import { convertToRaw } from 'draft-js'
import { useStyles } from './styles'

const EmailEditor = ({ formData, formRefs, setSaved, update }) => {
  const classes = useStyles()

  return (
    <>
      <Grid item xs={12} className={classes.muiEditor}>
        <MuiRte
          ref={formRefs.body}
          id="email-body"
          variant="contained"
          defaultValue={formData.body}
          onChange={(state) => {
            if (JSON.stringify(convertToRaw(state.getCurrentContent())) !== formData.body)
              setSaved(false)
          }}
          controls={['bold', 'italic', 'underline', 'link', 'bulletList']}
          onSave={(data) => update('body', { target: { value: data } })}
        />
      </Grid>
      <Grid item xs={12} className={classes.emailSigContainer}>
        <Typography variant="body1" className={classes.emailSig}>
          ---
          <br />
          <br />
          {formData.first_name} {formData.last_name}
          <br />
          {formData.address}
          <br />
          {formData.postcode}
        </Typography>
      </Grid>
    </>
  )
}

export default EmailEditor
